const styles = {
  page: {
    minHeight: "100vh",
    width: "100%",
    background: "var(--bg-page)",
    backgroundImage:
      "radial-gradient(color-mix(in srgb, var(--ink) 8%, transparent) 1px, transparent 1px), radial-gradient(color-mix(in srgb, var(--ink) 8%, transparent) 1px, transparent 1px)",
    backgroundSize: "24px 24px",
    backgroundPosition: "0 0, 12px 12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 28,
    fontFamily: "'Itim', cursive",
  },
  card: {
    background: "var(--bg-surface)",
    width: 440,
    maxWidth: "100%",
    padding: "48px 44px",
    textAlign: "center",
  },
  brandRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    marginBottom: 6,
  },
  brandDot: {
    width: 12,
    height: 12,
    borderRadius: "50%",
    background: "#F4B740",
    border: "2px solid var(--ink)",
  },
  brandText: {
    fontFamily: "'Itim', cursive",
    fontWeight: 700,
    color: "var(--accent-color)",
    fontSize: 15,
  },
  heading: {
    fontFamily: "'Itim', cursive",
    fontWeight: 700,
    fontSize: 32,
    color: "var(--ink)",
    margin: "4px 0 6px",
  },
  subheading: {
    color: "var(--ink-soft)",
    fontSize: 16,
    margin: "0 0 28px",
    lineHeight: 1.6,
  },
  emailHighlight: {
    color: "var(--ink)",
    fontWeight: 700,
  },
  otpRow: {
    display: "flex",
    justifyContent: "center",
    gap: 10,
    marginBottom: 8,
  },
  otpDigit: {
    width: 46,
    height: 56,
    textAlign: "center",
    fontSize: 26,
    fontFamily: "'Itim', cursive",
  },
  otpDigitError: {
    borderColor: "#E0473E",
  },
  errorText: {
    color: "#E0473E",
    fontSize: 13,
    marginTop: 5,
    fontWeight: 600,
  },
  successText: {
    color: "#2E8B4F",
    fontSize: 13,
    marginTop: 5,
    fontWeight: 600,
  },
  verifyBtn: {
    background: "var(--accent-color)",
    color: "#FFFDF8",
    fontSize: 18,
    padding: "12px 0",
    width: "100%",
    marginTop: 18,
  },
  resendRow: {
    marginTop: 18,
    fontSize: 14,
    color: "var(--ink-soft)",
  },
  resendBtn: {
    background: "none",
    border: "none",
    color: "var(--accent-color)",
    fontWeight: 700,
    fontSize: 14,
    cursor: "pointer",
    padding: 0,
    fontFamily: "'Itim', cursive",
  },
  resendBtnDisabled: {
    color: "var(--ink-faint)",
    cursor: "default",
  },
  backLink: {
    display: "inline-block",
    marginTop: 24,
    fontSize: 14,
    color: "var(--ink-faint)",
    textDecoration: "none",
  },
};

export default styles;
